// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowClassValue_wrapper__dUchn","valueWrapper":"ShowClassValue_valueWrapper__-IOde"};